import { jsx as _jsx } from "react/jsx-runtime";
import { ContactOpenedForm } from "@/components/contacting/ContactOpenedForm";
import { useStickyContactForm } from "../hooks/useStickyContactForm";
import { StickyContactFormA } from "../StickyContactFormA/StickyContactFormA";
import { StickyContactFormB } from "../StickyContactFormB/StickyContactFormB";
import { contactCardColumnTestId } from "./constants";
import { ContactCardColumnWrapper } from "./ui";
export const ContactCardColumn = () => {
    const isStickyContactVariantB = useStickyContactForm("b");
    const isStickyContactVariantC = useStickyContactForm("c");
    let contactForm;
    if (isStickyContactVariantB) {
        contactForm = _jsx(StickyContactFormA, {});
    }
    else if (isStickyContactVariantC) {
        contactForm = _jsx(StickyContactFormB, {});
    }
    else {
        contactForm = _jsx(ContactOpenedForm, {});
    }
    return (_jsx(ContactCardColumnWrapper, { testId: contactCardColumnTestId, children: contactForm }));
};
